// Handles toggling all footer collapsibles: clicking any trigger always closes all if any are open, or opens all if all are closed
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var triggers = document.querySelectorAll('.wt-footer__title.wt-collapse__trigger');
    if (!triggers.length) return;
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        var isDesktop = window.matchMedia('(min-width: 900px)').matches;
        if (!isDesktop) {
          // On mobile, allow native per-section toggle to proceed
          return;
        }
        // Desktop: override to open/close all
        e.preventDefault();
        e.stopPropagation();
        var allTargets = document.querySelectorAll('.wt-footer__body .wt-collapse__target');
        var allTriggers = document.querySelectorAll('.wt-footer__title.wt-collapse__trigger');
        // If any are open, close all. If all are closed, open all.
        var anyOpen = Array.from(allTargets).some(function(target) {
          return target.classList.contains('is-open');
        });
        if (anyOpen) {
          // Close all
          allTargets.forEach(function(target) {
            target.setAttribute('data-open', 'false');
            target.setAttribute('aria-expanded', 'false');
            target.style.display = '';
            target.classList.remove('is-open');
          });
          allTriggers.forEach(function(t) {
            t.setAttribute('data-open', 'false');
            t.setAttribute('aria-expanded', 'false');
            t.classList.remove('wt-collapse__trigger--active');
          });
        } else {
          // Open all
          allTargets.forEach(function(target) {
            target.setAttribute('data-open', 'true');
            target.setAttribute('aria-expanded', 'true');
            target.style.display = '';
            target.classList.add('is-open');
          });
          allTriggers.forEach(function(t) {
            t.setAttribute('data-open', 'true');
            t.setAttribute('aria-expanded', 'true');
            t.classList.add('wt-collapse__trigger--active');
          });
          // Scroll to bottom of page
          setTimeout(function() {
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
          }, 100);
        }
      }, true); // use capture to run before native handler
    });
  });
})();
